import React, { FunctionComponent } from 'react';

import usePalette from '@gojob/ui-bits/styles/PaletteProvider/usePalette';
import useTheme from '@gojob/ui-bits/styles/useTheme';
import Zigouigoui from '@gojob/ui-bits/Zigouigouis/ArrowLeft';

import BlockRenderer from './BlockRenderer';

export type ContentProps = {
  content?: any;
};

const useStyles = () => {
  const { breakpoint, spacing } = useTheme();

  return {
    content: {
      position: 'relative',
      margin: spacing(2.5, 0, 20),
      [breakpoint.up('lg')]: {
        width: '50%',
        flexShrink: 0,
      },
    },
    zigouigoui: {
      position: 'absolute',
      top: '100%',
      right: 0,
      transform: 'translate(0px, 26px) rotate(-27deg)',
      height: '15vh',
      [breakpoint.up('lg')]: {
        height: 'auto',
        transform: 'rotate(-15deg) rotateY(180deg)',
      },
    },
  } as const;
};

const Content: FunctionComponent<ContentProps> = (props) => {
  const { content } = props;
  const classes = useStyles();
  const { colors } = useTheme();
  const {
    button: { accent },
  } = usePalette();

  if (!content) {
    return null;
  }

  return (
    <div css={classes.content}>
      <BlockRenderer blocks={content} />
      <Zigouigoui color={colors[accent]} css={classes.zigouigoui} />
    </div>
  );
};

export default Content;
